// LocalStorage may not be available in some situations. E.g. due to browser support or in some setups in Incognito mode, so it's important to handle related errors correctly

export function getFromLocalStorageByKey(
  key: string,
): string | null | undefined {
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;

    return value;
  } catch (error) {
    console.warn(`Error getting ${key} from Local Storage`, error);
    return undefined;
  }
}

export function setInLocalStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn(`Error setting ${key} in Local Storage`, error);
  }
}
